/**
 * @generated SignedSource<<5d1537f4a6ae328bb5b882fbaa6147ae>>
 * @relayHash 0c12372d999250c67d6beec02276832c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5b171b801c0aa34ef9d708065ce3aad67c1a07cbc0a224a9b9e860aa8f8f8779

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { GlobalBrandingQuery } from './GlobalBrandingQuery.graphql';

const node: PreloadableConcreteRequest<GlobalBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5b171b801c0aa34ef9d708065ce3aad67c1a07cbc0a224a9b9e860aa8f8f8779",
    "metadata": {},
    "name": "GlobalBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
